import React, { Component, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ipc/ipc-components';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import locale from 'date-fns/locale/en-US';

if (locale && locale.options) {
  locale.options.weekStartsOn = 1;
}

class TotalPoolBreakdownReportSelectionCriteriaContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      validDate: true,
    };
  }

  onInvalidDate = (message) => {
    this.setState({
      validDate: message === '',
    });
  }

  isApplyEnabled = () => (this.state.validDate)

  togglePanel = () => {
    this.setState((prevState) => ({ open: !prevState.open }));
  };

  apply = () => {
    this.props.onApply();
    this.togglePanel();
  }

  render() {
    return (
      <div>
        <div className="selection-criteria-container">
          <h3 className="title-div">{this.props.title}</h3>
          <div className="operator-selector-wrapper">
            <div className="operators">
              <div className="operators-selection-panel">
                <div className="operator">
                  <div className="expand-div-button">
                    <h6>
                      SELECTION CRITERIA
                    </h6>
                    <div onClick={(e) => this.togglePanel(e)} className="expand-button">
                      <FontAwesomeIcon icon={this.state.open ? 'angle-down' : 'angle-right'} className="expand-icon" />
                    </div>
                  </div>
                  <div className={`checkboxtree-div ${this.state.open}`}>
                    <div>
                      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
                        <Grid container>
                          <KeyboardDatePicker
                            disableToolbar
                            autoOk
                            format="dd-MM-yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="Start Date: "
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            value={this.props.selectedStartDate}
                            onChange={this.props.onStartDateChange}
                            onError={this.onInvalidDate}
                          />
                        </Grid>
                        <Grid container>
                          <KeyboardDatePicker
                            disableToolbar
                            autoOk
                            format="dd-MM-yyyy"
                            margin="normal"
                            id="date-picker-inline"
                            label="End Date: "
                            KeyboardButtonProps={{
                              'aria-label': 'change date',
                            }}
                            value={this.props.selectedEndDate}
                            minDate={this.props.selectedStartDate}
                            onChange={this.props.onEndDateChange}
                            onError={this.onInvalidDate}
                          />
                        </Grid>
                      </MuiPickersUtilsProvider>
                    </div>
                    <div>
                      <Button
                        disabled={!this.isApplyEnabled()}
                        className={`apply-div-${!this.isApplyEnabled()}`}
                        onClick={this.apply}
                      >
                        APPLY
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

TotalPoolBreakdownReportSelectionCriteriaContainer.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  selectedStartDate: PropTypes.instanceOf(Date),
  onStartDateChange: PropTypes.func,
  selectedEndDate: PropTypes.instanceOf(Date),
  onEndDateChange: PropTypes.func,
  onApply: PropTypes.func,
};

TotalPoolBreakdownReportSelectionCriteriaContainer.defaultProps = {
  open: false,
};

export default TotalPoolBreakdownReportSelectionCriteriaContainer;
